import { Injectable } from "@angular/core";

export type CanDeactivateHandler = () => boolean | Promise<boolean>;

/**
 * Lets routed components register a leave guard so logout and other app-shell
 * actions can honour the same unsaved-changes flow as `canDeactivate` route guards.
 */
@Injectable({
  providedIn: "root",
})
export class ComponentDeactivateService {
  private handler: CanDeactivateHandler | null = null;

  register(handler: CanDeactivateHandler): void {
    this.handler = handler;
  }

  unregister(): void {
    this.handler = null;
  }

  async confirmLeave(): Promise<boolean> {
    if (!this.handler) {
      return true;
    }
    const result = this.handler();
    return result instanceof Promise ? await result : result;
  }
}
